import { render, staticRenderFns } from "./ProductImageUploads.vue?vue&type=template&id=22019654&scoped=true"
import script from "./ProductImageUploads.vue?vue&type=script&lang=js"
export * from "./ProductImageUploads.vue?vue&type=script&lang=js"
import style0 from "./ProductImageUploads.vue?vue&type=style&index=0&id=22019654&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22019654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22019654')) {
      api.createRecord('22019654', component.options)
    } else {
      api.reload('22019654', component.options)
    }
    module.hot.accept("./ProductImageUploads.vue?vue&type=template&id=22019654&scoped=true", function () {
      api.rerender('22019654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ProductImageUploads.vue"
export default component.exports